import Vue from 'vue'
import App from './App.vue'
// import PitchPrint from 'vue-pitchprint'

// Vue.use(PitchPrint);

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
